<div class="grid-background"></div>

 <div class="nav-buttons">
            <button class="nav-btn" [routerLink]="['/11plus-mocktest']">11plus Mock Test</button>
            <button class="nav-btn" [routerLink]="['/11Plus-classes']">11plus Classes</button>
        </div>
    
    <div class="hero-section">
       

        <div class="content-left">
            <h1 class="main-heading">11Plus</h1>
            <div class="sprint-text">
                SPRINT TO SUCCESS
                <span class="runner-icon">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="15" cy="4" r="2" fill="#0B7AB5"/>
                        <path d="M13 7L11 13L8 16L10 18L13 15L16 14L18 10L20 8L18 7L16 9L13 7Z" fill="#0B7AB5"/>
                        <path d="M4 18L6 20L9 17L7 15L4 18Z" fill="#0B7AB5"/>
                        <path d="M16 14L18 16L21 19L19 21L16 18L14 16L16 14Z" fill="#0B7AB5"/>
                    </svg>
                </span>
            </div>
            
            <p class="description">Weekly Sprint | 4 Hours of Learning Every Week including 2 Topic Tests (Papers), 2 Online Sessions & Detailed Result Analysis Report (RAR), Students Papers and Keys</p>
            <p class="dates">Face-to-Face (F2F) & Online</p>

            <div class="cta-buttons">
              <button class="cta-button" [routerLink]="['/11plus-mock-test']" [queryParams]="{ category: 39, scroll: 'calendar-section' }">Book Now</button>
            <button class="cta-button" (click)="downloadBrochure()">Download Brochure</button>
            </div>
            
            

        </div>


        <div class="roadmap-wrapper-main">
        <div class="roadmap-header-block">
            <h1>Road Map</h1>
            <p>Every step designed to help your child excel in 11+ Exam with confidence</p>
        </div>

        <div class="roadmap-visual-area">
            <svg class="roadmap-svg-path" viewBox="0 0 1300 500" preserveAspectRatio="xMidYMid meet">
                <!-- Road base -->
                <path class="roadmap-path-stroke" d="
                    M 0 250
                    L 50 250
                    C 100 250, 120 250, 150 200
                    C 180 150, 200 100, 230 70
                    C 260 40, 290 40, 320 70
                    C 350 100, 370 150, 400 200
                    C 430 250, 450 250, 500 250
                    C 550 250, 570 250, 600 200
                    C 630 150, 650 100, 680 70
                    C 710 40, 740 40, 770 70
                    C 800 100, 820 150, 850 200
                    C 880 250, 900 250, 950 250
                    C 1000 250, 1020 250, 1050 200
                    C 1080 150, 1100 100, 1130 70
                    C 1160 40, 1190 40, 1220 70
                    C 1250 100, 1270 150, 1300 200
                " />
                
                <!-- Road dashes -->
                <path class="roadmap-path-dashes" d="
                    M 0 250
                    L 50 250
                    C 100 250, 120 250, 150 200
                    C 180 150, 200 80, 230 50
                    C 260 20, 290 20, 320 50
                    C 350 80, 370 150, 400 200
                    C 430 250, 450 250, 500 250
                    C 550 250, 570 250, 600 200
                    C 630 150, 650 80, 680 50
                    C 710 20, 740 20, 770 50
                    C 800 80, 820 150, 850 200
                    C 880 250, 900 250, 950 250
                    C 1000 250, 1020 250, 1050 200
                    C 1080 150, 1100 80, 1130 50
                    C 1160 20, 1190 20, 1220 50
                    C 1250 80, 1270 150, 1300 200
                " />
            </svg>

            <div class="roadmap-connect-line roadmap-connect-line1"></div>
            <div class="roadmap-connect-line roadmap-connect-line2"></div>
            <div class="roadmap-connect-line roadmap-connect-line3"></div>
            <div class="roadmap-connect-line roadmap-connect-line4"></div>

            <div class="roadmap-icon-circle roadmap-icon-pos1">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="7" r="2.5" fill="white"/>
                    <circle cx="16" cy="7" r="2.5" fill="white"/>
                    <circle cx="12" cy="15" r="2.5" fill="white"/>
                    <path d="M12 18C10.5 18 9 19 8 20H16C15 19 13.5 18 12 18Z" fill="white"/>
                    <path d="M18 10L18 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 10L6 12" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>

            <div class="roadmap-icon-circle roadmap-icon-pos2">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="5" y="4" width="14" height="16" rx="1" stroke="white" stroke-width="2"/>
                    <path d="M9 8H15M9 12H15M9 16H13" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <circle cx="17" cy="17" r="3" fill="white"/>
                    <path d="M15.5 15.5L18.5 18.5" stroke="#E87251" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>

            <div class="roadmap-icon-circle roadmap-icon-pos3">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="8" r="2" stroke="white" stroke-width="2"/>
                    <path d="M12 10V14M10 14H14" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <rect x="4" y="16" width="6" height="5" rx="0.5" stroke="white" stroke-width="1.5"/>
                    <rect x="14" y="14" width="6" height="7" rx="0.5" stroke="white" stroke-width="1.5"/>
                    <rect x="9" y="18" width="6" height="3" rx="0.5" stroke="white" stroke-width="1.5"/>
                </svg>
            </div>

            <div class="roadmap-icon-circle roadmap-icon-pos4">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="4" y="8" width="16" height="11" rx="1" stroke="white" stroke-width="2"/>
                    <path d="M4 12H20" stroke="white" stroke-width="2"/>
                    <circle cx="12" cy="5" r="1.5" fill="white"/>
                    <path d="M12 6.5V8" stroke="white" stroke-width="2" stroke-linecap="round"/>
                    <path d="M7 15.5H9M11 15.5H13" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
        </div>

        <div class="roadmap-content-bottom">
            <div class="roadmap-milestone-item">
                <div class="roadmap-milestone-badge">Warm-up Session</div>
                <div class="roadmap-milestone-heading">Fri | 1 Hour | Online</div>
                <div class="roadmap-milestone-text">Quick concept recap to get test-ready</div>
            </div>

            <div class="roadmap-milestone-item">
                <div class="roadmap-milestone-badge">Topic Tests</div>
                <div class="roadmap-milestone-heading">Sat-Sun | 2 hrs | F2F</div>
                <div class="roadmap-milestone-text">Exam Hall based Tests in Real Exam Conditions</div>
            </div>

            <div class="roadmap-milestone-item">
                <div class="roadmap-milestone-badge">Result Analysis</div>
                <div class="roadmap-milestone-heading">Mon-Wed | RAR | Online</div>
                <div class="roadmap-milestone-text">Detailed Performance Analysis and Feedback — <strong>Rank, Percentile, Raw/High/Low/Avg Score, Std. Score and more.</strong></div>
            </div>

            <div class="roadmap-milestone-item">
                <div class="roadmap-milestone-badge">Doubt Session</div>
                <div class="roadmap-milestone-heading">Thu | 1 hour | Online:</div>
                <div class="roadmap-milestone-text">Live discussion to clear doubts and strengthen understanding.</div>
            </div>
        </div>
    </div>

    <div class="road-map-img">

      <img src="assets/images/roadmap.png" alt="roadmap">

    </div>

        <!-- <div class="content-right">
            <img src="assets/images/sprint.png" 
                 alt="Happy student with pilot helmet" 
                 class="student-image">
        </div> -->
    </div>


    <!-- pricing -->

    <div class="pricing-main">
      <div class="pricing-container">
  <div class="pricing-header">
    <h2 class="pricing-title">Pricing</h2>
    <div class="price-info">Everything You Need to Prepare and Success in 11+ Exam just for £20 / Week</div>
    <div class="price-description">for 4 Hours of learning including 2 Papers</div>
  </div>
  
  <div class="pricing-cards">
    <div class="pricing-card" *ngFor="let plan of pricingPlans">
  <div class="plan-header">
    <div class="plan-weeks">{{ plan.weeks }} WEEKS</div>
    <div class="plan-label">PLAN</div>
  </div>
  <ul class="features-list">
    <li class="feature-item" *ngFor="let feature of plan.features">
      <span class="check-icon">✓</span>
      <span class="feature-text">{{ feature }}</span>
    </li>
  </ul>
  <div class="discount-badge">
    <span class="original-price">{{ plan.originalPrice }}</span>
    {{ plan.discount }}
  </div>
  <div class="pricing-buttons">
    <div class="price-display">£{{ plan.finalPrice }}</div>
    <button class="buy-now-button" [routerLink]="['/11plus-mocktest']" [queryParams]="{ category: 39, scroll: 'calendar-section' }">Buy Now</button>
  </div>
</div>
  </div>
</div>
    </div>




    <!-- SUBJECT AND SUCCESS PLAN -->

    <!-- Subjects Header -->
    <section class="subjects-header">

      <div class="ribbon-content">
        <div class="subjects-title">
            <div class="icon-box">
                <svg class="icon-books" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="#1976D2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z" stroke="#1976D2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 6H16M8 10H16M8 14H12" stroke="#1976D2" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div class="sub">
              <h2>Subjects Covered</h2>
        <div class="subjects-list">
            Maths | English | Creative Writing | Non Verbal Reasoning | Verbal Reasoning
        </div>
            </div>
            
        </div>

        
      </div>

       
    </section>

    <!-- Success Plan Section -->
    <section class="success-plan">
        <h2 class="section-title">Success Plan</h2>
        
        <div class="plan-container">
            <div class="left-column">
                <div class="plan-cards-row">
                    <div class="plan-card">
                        <img src="https://res.cloudinary.com/dlddixhyu/image/upload/v1763050595/2149402649_opx4vh.jpg" alt="Students in classroom" class="card-image">
                        <div class="card-content">
                            <div class="card-duration">1Hour</div>
                            <div class="card-description">Online Class For Topic Overview & Exam Tips</div>
                        </div>
                    </div>

                    <div class="plan-card">
                        <img src="https://res.cloudinary.com/dlddixhyu/image/upload/v1763050593/2150104993_pzbp88.jpg" alt="Student taking exam" class="card-image">
                        <div class="card-content">
                            <div class="card-duration">2Hour</div>
                            <div class="card-description">Exam Hall Based Tests in Real Exam Conditions</div>
                        </div>
                    </div>

                    <div class="plan-card">
                        <img src="https://res.cloudinary.com/dlddixhyu/image/upload/v1763050593/2150470845_prmwro.jpg" alt="Doubt clearing session" class="card-image">
                        <div class="card-content">
                            <div class="card-duration">1Hour</div>
                            <div class="card-description">Doubt Clearing Session on Thursday</div>
                        </div>
                    </div>
                </div>

                <div class="info-card">
                    <img src="https://res.cloudinary.com/dlddixhyu/image/upload/v1763051010/generated-image_14_1_n4a86h.png" alt="Analytics report" class="info-image">
                    <div class="info-text">
                        Detailed <span class="highlight">Result Analysis Report(RAR)</span><br>
                        Consisting of Rank Percentile, Std. Score etc.
                    </div>
                </div>

                <div class="info-card">
                    <img src="https://res.cloudinary.com/dlddixhyu/image/upload/v1763050730/2149369867_xwbpqx.jpg" alt="Answer sheets" class="info-image">
                    <div class="info-text">
                        Students Papers & Detailed Answer Keys Booklet will be shared for Parents Review
                    </div>
                </div>
            </div>

            <div class="right-column">
                <img src="https://res.cloudinary.com/dlddixhyu/image/upload/v1763050594/elveptest_tvbz7q.jpg" alt="Student studying" class="main-image">
            </div>
        </div>
    </section>


    <!-- ROAD MAP -->

     
    <!-- SUCCESS STORIES -->

<div class="success-stories-container">
  <h2 class="section-title">Success Stories</h2>
  
  <div class="story-card" *ngFor="let story of stories">
    <div class="story-content">
      <div class="student-profile">
        <img [src]="story.image" [alt]="story.name" class="topper-image">
      </div>
      
      <div class="story-details">
        <div class="student-label">{{ story.label }}</div>
        <h3 class="student-name">{{ story.name }}</h3>
        <p class="achievement-text">{{ story.achievement }}</p>
      </div>
    </div>
    
    <div class="testimonial-box">
      <div class="testimonial-header">{{ story.testimonialHeader }}</div>
      <p class="testimonial-text">{{ story.testimonial }}</p>
    </div>
    
    <div class="closing-message">
      {{ story.closingMessage }}
    </div>
  </div>
</div>



    <!-- Weekly plan -->

<div class="weekly-session-container">
  <div class="header">
    <h1>Weekly Session Plan</h1>
  </div>
  
  <div class="sessions-grid">
    <div class="session-card" *ngFor="let week of weeks">
      <div class="week-title">Week {{ week.weekNumber }}</div>
      <div class="subject-list">
        <div class="subject-item" *ngFor="let subject of week.subjects">
          {{ subject }}
        </div>
      </div>
    </div>
  </div>
</div>



<!-- pricing.component.html -->
<!-- <div class="pricing-container">
  <div class="pricing-header">
    <h2 class="pricing-title">Pricing</h2>
    <div class="price-info">£20 / Week</div>
    <div class="price-description">for 4 Hours of learning including 2 Papers</div>
  </div>
  
  <div class="pricing-cards">
    <div class="pricing-card" *ngFor="let plan of pricingPlans">
      <div class="plan-header">
        <div class="plan-weeks">{{ plan.weeks }} WEEKS</div>
        <div class="plan-label">PLAN</div>
      </div>
      
      <ul class="features-list">
        <li class="feature-item" *ngFor="let feature of plan.features">
          <span class="check-icon">✓</span>
          <span class="feature-text">{{ feature }}</span>
        </li>
      </ul>
      
      <div class="discount-badge">
        <span class="original-price">{{ plan.originalPrice }}</span>
        {{ plan.discount }}
      </div>
      <button class="price-button">£{{ plan.finalPrice }}</button>
    </div>
  </div>
</div> -->